import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <Container sx={{ py: 6, borderTop: "1px solid #E5ECF4" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
          >
            <Grid item xs={2} sm={4} md={3}>
              <Box>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 700, mb: 3 }}
                  variant="h3"
                >
                  About Us
                </Typography>
                {/* links  */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Link to="/">Support Center</Link>
                  <Link to="/">Customer Support</Link>
                  <Link to="/">About Us</Link>
                  <Link to="/">Copyright</Link>
                  <Link to="/">Popular Campaign</Link>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <Box>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 700, mb: 3 }}
                  variant="h3"
                >
                  Our Information
                </Typography>
                {/* links  */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Link to="/">Return Policy</Link>
                  <Link to="/">Privacy Policy</Link>
                  <Link to="/">Terms & Conditions</Link>
                  <Link to="/">Site Map</Link>
                  <Link to="/">Store Hours</Link>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <Box>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 700, mb: 3 }}
                  variant="h3"
                >
                  My Account
                </Typography>
                {/* links  */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Link to="/">Press inquiries</Link>
                  <Link to="/">Social media</Link>
                  <Link to="/">directories</Link>
                  <Link to="/">Images & B-roll</Link>
                  <Link to="/">Permissions</Link>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <Box>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 700, mb: 3 }}
                  variant="h3"
                >
                  Policy
                </Typography>
                {/* links  */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Link to="/">Application security</Link>
                  <Link to="/">Software principles</Link>
                  <Link to="/">Unwanted software policy</Link>
                  <Link to="/">Responsible supply chain</Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Footer;
